import { createFileRoute } from "@tanstack/react-router";
import { type } from "arktype";

const schema = type({
  year: "number.integer",
  month: "number.integer",
});

export const Route = createFileRoute("/_myChimneyContext/summary")({
  validateSearch: schema,
});
